<template>
  <div>
    <app-tile-group
      :model-value="envelopeType"
      :options="envelopeTypeTileOptions"
      :disabled="isEditingLimited"
      :aria-label="$t('project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeLabel')"
      data-locator="envelope-type-tile-group"
      @update:model-value="onEnvelopeTypeChange"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { formFieldErrors, VuelidateFormField } from '@/common/utils/form'
import type { TileOption } from '@/design-system/tiles/types'
import { ENVELOPE_TYPES } from '@/project/signing-checklist/constants'

export default defineComponent({
  name: 'SigningChecklistSectionDocumentEnvelopeType',
  props: {
    envelopeType: {
      type: String,
      required: true,
    },
    isEditingLimited: {
      type: Boolean,
      required: true,
    },
    isMultiEnvelopeChild: {
      type: Boolean,
      required: true,
    },
    envelopeTypeValidator: {
      type: Object as PropType<VuelidateFormField>,
      required: true,
    },
  },
  computed: {
    envelopeTypeOptions (): string[] {
      return Object.values(ENVELOPE_TYPES).filter((type) => type !== ENVELOPE_TYPES.NDA)
    },
    envelopeTypeTileOptions (): TileOption[] {
      return this.envelopeTypeOptions.map(option => ({
        value: option,
        label: this.getTileLabel(option),
        caption: this.$t(`project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeOptions.${option}Info`),
        dataLocator: `${option}-envelope-type-card`,
      }))
    },
    envelopeTypeErrorMessages () {
      return formFieldErrors(
        this.envelopeTypeValidator,
        [
          ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeLabel') })],
        ],
      )
    },
  },
  methods: {
    getTileLabel (option: string): string {
      const label = this.$t(`project.signing-checklist.add.SigningChecklistSectionDocumentEnvelopeType.envelopeTypeOptions.${option}`)
      if (option === ENVELOPE_TYPES.SINGLE && this.isMultiEnvelopeChild) {
        return `${label} (${this.$t('common.envelopeType.fromBulk')})`
      }
      return label
    },
    onEnvelopeTypeChange (value: string | null) {
      this.$emit('envelope-type-change', value)
    },
  },
})
</script>
